// Import model
import { CreateDoorRequest } from '../models/CreateDoorRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreatePointRequest } from '../models/CreatePointRequest';

// Import dependency serializers (for complex types)
import { CreatePointRequestSerializer } from './CreatePointRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateDoorRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateDoorRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateDoorRequest instance
   */
  static deserialize(json: string): CreateDoorRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateDoorRequest instance
   */
  static fromObject(obj: any): CreateDoorRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateDoorRequest');
    }


    const instance: CreateDoorRequest = {
      addTransition: obj['addTransition'] as boolean | undefined,
      name: obj['name'] as string,
      trimDoor: obj['trimDoor'] as boolean | undefined,
      wallIndex: obj['wallIndex'] as number | undefined,
      width: obj['width'] as number | undefined,
      isOpening: obj['isOpening'] as boolean | undefined,
      offset: obj['offset'] as number | undefined,
      shape: obj['shape'] ? (obj['shape'] as any[]).map((item: any) =>
        CreatePointRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateDoorRequest instances
   */
  static deserializeArray(json: string): CreateDoorRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateDoorRequest instance to a JSON string
   */
  static serialize(instance: CreateDoorRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateDoorRequest instance to a plain object
   */
  static toObject(instance: CreateDoorRequest): any {
    return {
      'addTransition': instance.addTransition,
      'name': instance.name,
      'trimDoor': instance.trimDoor,
      'wallIndex': instance.wallIndex,
      'width': instance.width,
      'isOpening': instance.isOpening,
      'offset': instance.offset,
      'shape': instance.shape?.map((item: any) =>
        CreatePointRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of CreateDoorRequest instances to a JSON string
   */
  static serializeArray(instances: CreateDoorRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
